import { Injectable } from '@angular/core';
import { RevoGrid } from '@revolist/revogrid/dist/types/interfaces';
import { VNode } from '@revolist/revogrid/dist/types/stencil-public-runtime';
import { formatDate } from '@angular/common';
import { DateFormatView } from 'src/app/shared/shared.const';
import * as moment from 'moment';


@Injectable({
    providedIn: 'root'
})
export class RevoGridService {

    constructor() { }

    generateRevoGridColumns(columns: any[], buttons: any[] = []) {
        var revoGridColumns: RevoGrid.CellProps[] = [];
        for (var i = 0; i < columns.length; i++) {
            var column = columns[i];
            revoGridColumns.push({
                name: column.name,
                prop: column.prop,
                type: column.type,
                dateFormat: column.dateFormat,
                size: column.size != undefined ? column.size : 120,
                autoSize: column.autoSize != undefined ? column.autoSize : true,
                sortable: column.sortable != undefined ? column.sortable : true,
                pin: column.pin,
                fnModify: column.fnModify,
                fnCall: column.fnCall,
                onChange: column.onChange,
                className: column.className,
                showCheckIfValue: column.showCheckIfValue,
                columnProperties: (column: RevoGrid.ColumnRegular) => {
                    if (column.type === 'questionnaire') {
                        return {
                            class: column.className
                        };
                    }
                },
                columnTemplate: (createElement: RevoGrid.HyperFunc<VNode>, column: RevoGrid.ColumnRegular) => {
                    return column.name;
                },
                cellTemplate: (createElement: RevoGrid.HyperFunc<VNode>, props: RevoGrid.ColumnDataSchemaModel) => {
                    if (props.column.type === 'questionnaire') {
                        return this.generateRevoGridQuestionnaire(createElement, props);
                    }
                    else if (props.column.type === 'check') {
                        return this.generateRevoGridCheckIcon(createElement, props);
                    }
                    else if (props.column.type === 'checkbox') {
                        return this.generateRevoGridCheckBox(createElement, props);
                    }
                    else {
                        return this.generateRevoGridTemplate(createElement, props);
                    }

                }
            })
        }

        if (buttons.length) {
            var actionSize = 0;
            buttons.forEach(btn => {
                if (btn.icon) {
                    actionSize += 47;
                } else {
                    let w = (btn.name.length * 10) + 20;
                    if (w < 60) {
                        w = 60;
                    }
                    actionSize += w;
                }
            })
            if (actionSize < 80) {
                actionSize = 80;
            }
            revoGridColumns.push({
                name: 'Aktion',
                prop: 'Id',
                buttons: buttons,
                size: actionSize,
                pin: 'colPinEnd',
                columnTemplate: (createElement: RevoGrid.HyperFunc<VNode>, column: RevoGrid.ColumnRegular) => {
                    const divElem = createElement('div', {
                        class: 'text-center'
                    }, column.name);

                    return divElem;
                },
                cellTemplate: (createElement: RevoGrid.HyperFunc<VNode>, props: RevoGrid.ColumnDataSchemaModel) => {
                    return this.generateRevoGridButtons(createElement, props);
                }
            })
        }

        return revoGridColumns;
    }

    generateRevoGridQuestionnaire(createElement: RevoGrid.HyperFunc<VNode>, props: RevoGrid.ColumnDataSchemaModel) {
        var Id = props.model["Id"];
        var questionnaires = props.model[props.prop];
        questionnaires = questionnaires.sort((a, b) => a.Order - b.Order);

        var icons: any[] = [];
        questionnaires.forEach(quest => {
            var status = "disabled";
            if (quest.Status && quest.Status.length > 0) {
                status = quest.Status.toLowerCase();
            }
            var title = quest.QuestId;
            if (quest.ButtonText) {
                title += ` (${quest.ButtonText})`;
            }

            const icon = createElement('img', {
                class: `mx-1 cursor-pointer`,
                title: title,
                src: `assets/icons/quest-${status}.svg`,
                onclick: (event: any) => {
                    var fnCall = props.column.fnCall;
                    if (fnCall) {
                        fnCall(Id, quest);
                    }
                    event.stopPropagation();
                }
            })
            icons.push(icon);
        })

        let style = {
            padding: "0px"
        };

        const divElem = createElement('div', {
            style: style,
            class: props.column.className
        }, icons);
        return divElem;
    }

    generateRevoGridCheckIcon(createElement: RevoGrid.HyperFunc<VNode>, props: RevoGrid.ColumnDataSchemaModel) {
        var Id = props.model["Id"];
        var value = props.model[props.prop];
        var showCheckIfValue = props.column.showCheckIfValue;

        if (value != showCheckIfValue) {
            return ``;
        }
        const icon = createElement('img', {
            class: `d-block m-auto cursor-pointer`,
            src: `assets/icons/check-green.svg`,
            onclick: (event: any) => {
                var fnCall = props.column.fnCall;
                if (fnCall) {
                    fnCall(Id);
                }
                event.stopPropagation();
            }
        })

        const divElem = createElement('div', {
            class: `d-flex ${props.column.className}`,
        }, icon);
        return divElem;
    }

    generateRevoGridCheckBox(createElement: RevoGrid.HyperFunc<VNode>, props: RevoGrid.ColumnDataSchemaModel) {
        var Id = props.model["Id"];
        const input = createElement("input", {
            type: "checkbox",
            style: {
                scale: 1.5
            },
            // store is selected in rows "checked" prop
            checked: props.model["checked"],
            onChange(event) {
                props.model["checked"] = event.target.checked;
                if (input) {
                    input.$attrs$.checked = event.target.checked;
                }
                var onChange = props.column.onChange;
                if (onChange) {
                    onChange(props.model.checked, Id);
                }
                event.stopPropagation();
            }
        });

        const divElem = createElement('div', {
            class: props.column.className,
        }, input);
        return divElem;
    }

    generateRevoGridTemplate(createElement: RevoGrid.HyperFunc<VNode>, props: RevoGrid.ColumnDataSchemaModel) {
        var Id = props.model["Id"];
        let title = props.model[props.prop];
        var fnModify = props.column.fnModify;
        if (fnModify) {
            title = fnModify(title);
        } else {
            if (props.column.type == "date") {
                title = props.model[props.prop] || '';
                if (title) {
                    let format = props.column.dateFormat || DateFormatView;
                    let locale = moment.locale();
                    let timeZone = moment().format("ZZ");
                    title = formatDate(new Date(title), format, locale, timeZone);
                }
            }
            else if (props.column.type == "json") {
                if (typeof title === "object") {
                    title = JSON.stringify(title);
                }
            } else if (props.column.type === 'boolean') {
                title = title ? `Yes` : `No`;
            }
            else if (title) {
                if (props.column.type === 'integer') {
                    title = Math.round(title);
                } else if (props.column.type === 'decimal') {
                    title = props.column.placeValue ? parseFloat(title).toFixed(props.column.placeValue) : parseFloat(title);
                }
            } else {
                title = title || "";
            }
        }

        let bgStyle = {};
        let colorStyle = {};

        const spanElem = createElement('span', {
            style: colorStyle
        }, title);

        const divElem = createElement('div', {
            title: title,
            style: bgStyle,
            class: props.column.className,
            onclick: (event: any) => {
                var fnCall = props.column.fnCall;
                if (fnCall) {
                    fnCall(Id);
                }
                event.stopPropagation();
            },
            onDblclick: (event: any) => {
                event.stopPropagation();
            }
        }, spanElem);
        return divElem;
    }

    generateRevoGridButtons(createElement: RevoGrid.HyperFunc<VNode>, props: RevoGrid.ColumnDataSchemaModel) {
        let Id = props.model[props.prop]
        var buttons = props.column.buttons;

        var buttonElems: any[] = [];
        buttons.forEach(button => {
            let showButton: boolean = false;
            let BtnId = props.model[button.prop];
            let fnShow = button.fnShow;
            if (fnShow) {
                showButton = fnShow(BtnId);
            } else if (BtnId) {
                showButton = true;
            }

            if (showButton) {
                const elem = button.icon ?
                    createElement('img', {
                        src: `assets/icons/${button.icon}.svg`
                    }) : button.name;

                const buttonElem = createElement('button', {
                    class: `mx-1 btn btn-sm ${button.class}`,
                    title: button.name,
                    onclick: (event: any) => {
                        let fnCall = button.fnCall;
                        if (fnCall) {
                            fnCall(Id);
                        }
                        event.stopPropagation();
                    }
                }, elem);
                buttonElems.push(buttonElem);
            }
        })
        const divElem = createElement('div', {
            class: 'text-center p-0'
        }, buttonElems);

        return divElem;
    }

}